// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1oWqr","title":"ClientReferral_title__2E4jI","itemText":"ClientReferral_itemText__2M4kC"};